<template>
  <v-card
    outlined
    class="mt-3"
  >
    <v-card-text>
      <div class="d-flex">
        <strong>Payments ({{ payments.length }})</strong>
        <v-spacer />
        <v-btn
          :disabled="checkDue"
          icon
          class="success--text"
          @click="show = true"
        >
          <v-icon>mdi-plus-circle</v-icon>
        </v-btn>
      </div>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Status
              </th>
              <th class="text-left">
                Method
              </th>
              <th class="text-left">
                Amount
              </th>
              <th class="text-left">
                Gateway
              </th>
              <th class="text-left">
                Note
              </th>
              <th class="text-left">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="payment in payments"
              :key="payment.id"
            >
              <td>
                <template v-if="payment.status">
                  <v-icon class="success--text">
                    mdi-check-circle
                  </v-icon>
                </template>
                <template v-else>
                  <v-icon class="error--text">
                    mdi-minus-circle
                  </v-icon>
                </template>
              </td>
              <td>{{ payment.method ? "Cash" : "On Credit" }}</td>
              <td>{{ payment.amount | currency }}</td>
              <td>{{ payment.gateway }}</td>
              <td>{{ payment.note | truncate(20) | capitalize }}</td>
              <td>
                <v-icon
                  small
                  @click="paymentEdit(payment)"
                >
                  mdi-pen
                </v-icon>
                <v-icon
                  small
                  @click="
                    $router.push({
                      name: 'PaymentDetails',
                      params: { id: payment.id },
                    })
                  "
                >
                  mdi-eye
                </v-icon>
                <v-icon
                  small
                  @click="removePay(payment.id)"
                >
                  mdi-delete
                </v-icon>
              </td>
            </tr>
            <tr
              v-if="dueAmount > 0"
              class="active error--text"
            >
              <th>Due Amount</th>
              <td colspan="5">
                {{ dueAmount | currency }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-text v-if="show">
      <div class="mb-5">
        Make Payment
      </div>
      <v-row>
        <v-col
          cols="12"
          md="6"
          sm="12"
        >
          <v-text-field
            v-model="form.amount"
            hide-details="auto"
            label="Enter Amount"
            outlined
            dense
            type="number"
            :error-messages="errors.getMessage('amount')"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          sm="12"
        >
          <v-select
            v-model="form.gateway"
            :items="gateways"
            outlined
            label="Select gateway"
            dense
            :error-messages="errors.getMessage('gateway')"
          />
        </v-col>
        <v-col
          cols="12"
          class="pt-0 mt-0"
        >
          <v-textarea
            v-model="form.note"
            label="Payment Note"
            :placeholder="
              'Write information about ' + form.gateway + ' payment gateway'
            "
            outlined
            rows="2"
            dense
            :error-messages="errors.getMessage('note')"
          />
          <v-switch
            v-model="form.status"
            label="Mark Paid"
            hide-details
          />
        </v-col>
      </v-row>
      <v-btn
        color="info"
        @click="submitPayment"
      >
        Proceed
      </v-btn>
      <v-btn
        color="warning"
        @click="show = false"
      >
        Cancel
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    orderId: { type: String | Number, required: true },
  },
  data() {
    return {
      isEditing: false,
      show: false,
      payments: [],
      dueAmount: 0,
      form: {
        order_id: this.orderId,
        gateway: "cash",
        status: true,
        method: true,
      },
      gateways: ["card", "cheque", "cash", "other"],
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
    checkDue() {
      return this.$data.dueAmount < 1;
    },
  },
  watch: {
    dueAmount() {
      this.$data.form.amount = this.$data.dueAmount;
    },
  },

  mounted() {
    this.gatFromApi();
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    paymentEdit(payment) {
      this.$data.form = payment;
      this.$data.isEditing = true;
      this.$data.show = true;
    },
    gatFromApi() {
      this.$data.form = {};
      window.axios.get("/order-payments/" + this.orderId).then((response) => {
        this.$data.payments = response.data.payments;
        this.$data.dueAmount = response.data.due;
        this.$data.show = false;
        this.$data.isEditing = false;
      });
    },
    createPayment() {
      window.axios
        .post("/make-payment/" + this.orderId, this.$data.form)
        .then((response) => {
          this.feedback(response.data.message);
          this.gatFromApi();
        });
    },
    updatePayment() {
      window.axios
        .patch("/payment/" + this.$data.form.id, this.$data.form)
        .then((response) => {
          this.feedback(response.data.message);
          this.gatFromApi();
        });
    },
    submitPayment() {
      if (this.$data.isEditing) {
        this.updatePayment();
      } else {
        this.createPayment();
      }
    },
    removePay(payId) {
      window.axios.delete("/payment/" + payId).then((response) => {
        this.gatFromApi();
        this.feedback(response.data.message);
      });
    },
  },
};
</script>
